import { render, staticRenderFns } from "./MoeFooter.vue?vue&type=template&id=a2c91844&scoped=true&"
import script from "./MoeFooter.vue?vue&type=script&lang=js&"
export * from "./MoeFooter.vue?vue&type=script&lang=js&"
import style0 from "./MoeFooter.vue?vue&type=style&index=0&id=a2c91844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c91844",
  null
  
)

export default component.exports